import { cn } from "@/lib/utils";

const AMBER = "bg-amber-500/10 text-amber-700 border-amber-500/25";
const VIOLET = "bg-violet-500/10 text-violet-700 border-violet-500/25";
const CYAN = "bg-cyan-500/10 text-cyan-700 border-cyan-500/25";
const INDIGO = "bg-indigo-500/10 text-indigo-700 border-indigo-500/25";
const BLUE = "bg-blue-500/10 text-blue-700 border-blue-500/25";
const SKY = "bg-sky-500/10 text-sky-700 border-sky-500/25";
const TEAL = "bg-teal-500/10 text-teal-700 border-teal-500/25";
const EMERALD = "bg-emerald-500/10 text-emerald-700 border-emerald-500/25";
const ROSE = "bg-rose-500/10 text-rose-700 border-rose-500/25";
const SLATE = "bg-slate-500/10 text-slate-700 border-slate-500/20";

export const STATUS_META = {
  Booked: { label: "Booked", cls: AMBER },
  "Received at Warehouse": { label: "Received at Warehouse", cls: TEAL },
  Delivered: { label: "Delivered", cls: EMERALD },
  Cancelled: { label: "Cancelled", cls: ROSE },
};

export const STATUS_OPTIONS = ["Booked", "Received at Warehouse", "Delivered"];

export const STATUS_FLOW = STATUS_OPTIONS;

// Free-text statuses get a tone from keywords so the timeline stays colourful.
const toneFor = (s = "") => {
  if (/deliver/i.test(s) && !/out for/i.test(s)) return EMERALD;
  if (/cancel|hold|delay|fail|return|damage|issue/i.test(s)) return ROSE;
  if (/received|hub|warehouse|arriv/i.test(s)) return TEAL;
  if (/out for|dispatch/i.test(s)) return BLUE;
  if (/transit|depart|flight|manifest|airline|custom|clearance/i.test(s)) return INDIGO;
  if (/picked|pickup/i.test(s)) return VIOLET;
  if (/label|book|created/i.test(s)) return AMBER;
  return SLATE;
};

export default function StatusBadge({ status, testId, className }) {
  const pretty = /^[A-Z0-9_]+$/.test(status || "")
    ? String(status).toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : status;
  const meta = STATUS_META[status] || { label: pretty || "—", cls: toneFor(status) };
  const live = !/deliver|cancel/i.test(meta.label);
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-wide whitespace-nowrap shadow-sm",
        meta.cls,
        className
      )}
    >
      <span className="relative flex h-1.5 w-1.5">
        {live && <span className="absolute inline-flex h-full w-full rounded-full bg-current opacity-60 animate-ping" />}
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-current" />
      </span>
      {meta.label}
    </span>
  );
}
